import { render, staticRenderFns } from "./QuestionAnswersView.vue?vue&type=template&id=55d1c596&scoped=true&"
import script from "./QuestionAnswersView.vue?vue&type=script&lang=js&"
export * from "./QuestionAnswersView.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAnswersView.vue?vue&type=style&index=0&id=55d1c596&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d1c596",
  null
  
)

export default component.exports